import Chart from "react-apexcharts";

export interface Props {
  getCashCollectionState4Data: any;
}

export default function CollectionPointCart({
  getCashCollectionState4Data,
}: Props) {
  const pieData = getCashCollectionState4Data?.data;
  const covered = pieData?.collectionPercentage;
  const remaning =
    pieData?.activeCollectionPointCount - pieData?.uniqueCashCollectionCount;

  const series = [covered, remaning];
  const labels = ["Covered", "Remaining"];
  const colors = ["#9FD7FF", "#FFCF74"];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "pie",
      height: 450,
    },
    labels: labels,
    colors: colors,
    legend: {
      position: "bottom",
      labels: {
        useSeriesColors: true, // match legend color with slice
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "1rem",
        fontWeight: "bold",
      },
      formatter: function (_val: number, opts: any) {
        // Show the raw values inside each slice
        return series[opts.seriesIndex].toString();
      },
    },
    tooltip: {
      y: {
        formatter: function (val: number, opts: any) {
          return `${val}`;
        },
      },
    },
  };

  return (
    <>
      <Chart
        options={options}
        series={series}
        type="pie"
        width={350}
        height={450}
      />
    </>
  );
}
